<template>
  <div class="address-list">
    <div class="address-list__header">
      <div>
        {{ trans('addresses.body.table.space') }}
        <span>{{ trans('global.and') }} {{ trans('addresses.body.table.address') }}</span>
      </div>

      <div class="address-list-notify-helper">
        <span>{{ trans('addresses.body.table.contacts') }}</span>
        <span class="tooltip">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="tooltiptext"
            v-html="trans('addresses.body.table.contacts.tooltip')"
          /></span>
        <!-- eslint-enable vue/no-v-html -->
      </div>

      <div>{{ trans('addresses.body.table.offers') }}</div>
    </div>

    <AddressForm
      v-if="addressAddMode"
      @created="changed"
      @cancelled="addCancelled"
    />

    <AddressRow
      v-for="(address) in addresses"
      :key="address.id"
      :address="address"
      @deleted="changed"
      @edited="changed"
    />
  </div>
</template>

<script>
import translation from '@elements/translation';
import AddressForm from './AddressForm.vue';
import AddressRow from './AddressRow.vue';

export default {
  components: { AddressForm, AddressRow },
  mixins: [ translation ],
  props: {
    addresses: { type: Array, default: () => [] },
    addressAddMode: { type: Boolean, default: false },
  },
  methods: {
    changed() {
      this.$emit('changed');
    },
    addCancelled() {
      this.$emit('add-cancelled');
    },
  },
};
</script>
